





























import { Component, Prop, PropSync, Ref, Vue } from 'vue-property-decorator'
import SortInput from '@/components/SortInput.vue'
import NewsCard from '@/components/NewsCard.vue'
import DotsLoader from '@/components/DotsLoader.vue'
import { context } from '@/store/modules'
import Draggable from 'vuedraggable'

@Component({
  components: { DotsLoader, NewsCard, SortInput, Draggable }
})
export default class ScrollList extends Vue {
  @Prop({ default: '' })
  title: string

  @Prop({ type: Boolean, default: false })
  draggable: boolean

  @PropSync('items', { default: () => [] })
  itemsSync: any[]

  @Prop({ type: Boolean, default: false })
  active: boolean

  @Prop({ default: null })
  sortProperty: string | null

  @Prop({ default: 'value' })
  keyProperty: string

  @Prop({ type: Boolean, default: false })
  loading: boolean

  @Prop({ default: 24 })
  gap: number

  @Prop({ default: 0 })
  spacing: number

  @Ref()
  ps: Vue

  get sortAsc () {
    return context.sortAsc
  }

  set sortAsc (value: boolean) {
    context.setSortAsc(value)
  }

  mounted () {
    if (this.ps?.$refs.container) {
      const psContainer = this.ps.$refs.container as Element
      psContainer.addEventListener('scroll', this.onScroll)
    }
  }

  destroy () {
    if (this.ps?.$refs.container) {
      const psContainer = this.ps.$refs.container as Element
      psContainer.removeEventListener('scroll', this.onScroll)
    }
  }

  getValue (item: any, target: string) {
    return target.split('.').reduce((o, i) => o[i], item)
  }

  onScroll (e: Event) {
    const target = e.target as HTMLElement
    if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
      this.$emit('scroll:end')
    }
  }
}
